<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisField from 'dashboard/components-next/LaisField.vue';
import {
  catalogConnectionIsOpen,
  catalogConnectionLabel,
} from '../utils/whatsappCatalog';

const props = defineProps({
  connections: { type: Array, default: () => [] },
  modelValue: { type: [String, Number], default: '' },
  connected: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'refresh']);

const connectionOptions = computed(() =>
  props.connections.map(connection => ({
    ...connection,
    label: catalogConnectionLabel(connection),
    isOpen: catalogConnectionIsOpen(connection),
  }))
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div
    class="flex flex-col gap-3 rounded-lais border border-lais-border-soft bg-white p-4 lg:flex-row lg:items-end lg:justify-between"
  >
    <LaisField label="Conta WhatsApp" class="min-w-0 flex-1">
      <select
        :value="modelValue"
        class="h-11 w-full rounded-lais-sm border border-lais-border bg-white px-3 text-[13px] text-lais-text outline-none transition focus:border-lais-primary focus:ring-2 focus:ring-lais-primary/10"
        @change="emit('update:modelValue', $event.target.value)"
      >
        <option value="">Selecione uma conexão</option>
        <option
          v-for="connection in connectionOptions"
          :key="connection.id"
          :value="connection.id"
        >
          {{ connection.label
          }}{{ connection.isOpen ? ' · Conectada' : ' · Desconectada' }}
        </option>
      </select>
    </LaisField>

    <div class="flex flex-wrap items-center gap-2">
      <span
        class="inline-flex h-9 items-center gap-2 rounded-full px-3 text-[12px] font-semibold"
        :class="
          connected
            ? 'bg-emerald-50 text-emerald-700'
            : 'bg-amber-50 text-amber-800'
        "
      >
        <span
          class="size-2 rounded-full"
          :class="connected ? 'bg-emerald-500' : 'bg-amber-500'"
        />
        {{ connected ? 'Sessão conectada' : 'Sessão desconectada' }}
      </span>
      <button
        type="button"
        class="inline-flex h-9 items-center gap-2 rounded-lais-sm border border-lais-border px-3 text-[12px] font-semibold text-lais-primary transition hover:border-lais-primary/50 disabled:cursor-not-allowed disabled:opacity-50"
        :disabled="!modelValue"
        @click="emit('refresh')"
      >
        <span class="i-lucide-refresh-cw size-3.5" />
        Atualizar
      </button>
    </div>
  </div>
</template>
